import client from '../config/AxiosConfig';

export const GetTemplates = async (currentPage, limit, filters) => await client.get(`/email_templates/${currentPage}/${limit}?filter=${filters}`);

export const GetTemplate = async (id) => await client.get(`/email_templates/${id}`);

export const UpdateTemplate = async (id, data) => await client.put(`/email_templates/${id}`, data);